import Typography from 'typography';

const createTypography = ({ baseSize, baseLineHeight }) => {
  return new Typography({
    baseFontSize: `${baseSize}px`,
    baseLineHeight,
    googleFonts: [
      {
        name: 'Comfortaa',
        styles: ['300', '400', '700'],
      },
    ],
    headerFontFamily: ['Comfortaa', 'sans-serif'],
    bodyFontFamily: ['Comfortaa', 'sans-serif'],
    headerColor: 'hsla(0,0%,0%,1)',
    bodyColor: 'hsla(0,0%,0%,0.8)',
    bodyWeight: 300,
    headerWeight: 400,
    boldWeight: 700,
  });
};

const baseSize = 16;
const baseLineHeight = 1.5;
export const baseMargin = baseSize * baseLineHeight;
export const baseMarginMultiplier = 4;

export default createTypography({ baseSize, baseLineHeight });
